import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Tabs, Tab } from "react-bootstrap";

//
import Earnings from "../../../components/account/referral/Earnings";
import Invite from "../../../components/account/referral/Invite";
import Invitation from "../../../components/account/referral/Invitation";
import Terms from "../../../components/account/referral/Terms";

function Referral({ windowSize }) {
  return (
    <div className="referral">
      <Invite />

      {windowSize > 576 ? (
        <>
          <Earnings />
          <Invitation />
          <Terms />
        </>
      ) : (
        <Tabs defaultActiveKey="earning">
          <Tab eventKey="earning" title="Earnings" mountOnEnter unmountOnExit>
            <Earnings />
          </Tab>
          <Tab
            eventKey="invitations"
            title="Invitations"
            mountOnEnter
            unmountOnExit
          >
            <Invitation />
          </Tab>
          <Tab
            eventKey="terms"
            title="Program Terms"
            mountOnEnter
            unmountOnExit
          >
            <Terms />
          </Tab>
        </Tabs>
      )}
    </div>
  );
}

Referral.propTypes = {
  windowSize: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(Referral);
